import AbsolutePane from './_absolute-pane.js'
import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import BetslipSettings from './_betslip-settings.js'
import BetslipNotifications from './_betslip-notifications.js'
import PlaceBetContent from './_place-bet-content.js'

export default {
  name: 'Betslip',
  values: {
    showBetslipSettingsInEmptyBetslip: false,
    disabledOverlay: {
      configSet: AbsolutePane,
      configValues: {
        style: {
          width: '100%',
          height: '100%',
          zIndex: 1,
        },
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    innerContainer: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          width: '100%',
          height: '100%',
          flexDirection: 'column',
        },
      },
    },
    emptyBetslipTextContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          height: '90px',
          padding: '10px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
    emptyBetslipText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    betslipSettingsContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    betslipSettings: {
      configSet: BetslipSettings,
      configValues: {},
    },
    betslipNotifications: {
      configSet: BetslipNotifications,
      configValues: {
        notificationsMap: {
          BET_BUILDER_NON_COMBINABLE: 'ignore',
        },
      },
    },
    placeBetContent: {
      configSet: PlaceBetContent,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
